import { isEqual } from 'lodash'
import { getCompanyContactListData } from '../companyContacts/mockData'
import { getSupplierContactListData } from '../supplierContacts/mockData'
import { getTsdContactListData } from '../tsdContacts/mockData'
import { getLeadSourceContactListData } from '../selectLists/leadSourceContacts/mockData'
import type { TContact } from '~/types/contact/models'
import type { TEntityId } from '~/types/models'

export async function getContactListData(): Promise<TContact[]> {
  const companyListData = await getCompanyContactListData()
  const supplierListData = await getSupplierContactListData()
  const tsdListData = await getTsdContactListData()
  const leadSourceListData = await getLeadSourceContactListData()
  const contactListData: TContact[] = [
    ...companyListData,
    ...supplierListData,
    ...tsdListData,
    ...leadSourceListData,
  ]
  return contactListData.sort((a, b) =>
    a.person.name.lastName > b.person.name.lastName ? 1 : -1
  )
}

export function _getCDataById(id: TEntityId, list: TContact[]): TContact {
  if (!list) {
    throw new Error(`_getCDataById returned undefined/null`)
  }
  const contact = list.find((c: TContact) => c.id === id)
  if (!contact) {
    throw new Error(`Can't find contact '${id}'`)
  }
  return contact
}

export async function getContactDataById(id: TEntityId): Promise<TContact> {
  const list = await getContactListData()
  if (!list) {
    throw new Error(`getContactList returned undefined/null`)
  }
  const contact = list.find((c) => c.id === id)
  if (!contact) {
    throw new Error(`Can't find contact '${id}'`)
  }
  return contact
}

export async function getContactListDataByPersonId(id: string) {
  const list = await getContactListData()
  return list.filter((contact) => isEqual(contact.person.id, id))
}
